<!--
 * @Description: file content
 * @Author: 前胡
 * @LastEditors: 前胡
 * @Date: 2020-05-05 10:06:21
 * @LastEditTime: 2020-07-14 16:50:41
 -->
<template>
  <div>
    <template v-if="slides && slides.length">
      <div class="form-list-panel" v-for="(slide, idx) in slides" :key="idx">
        <upload
          :label="'图片' + (idx + 1)"
          :index="idx"
          :item="slide"
          :allItems="slides"
          ref="upload"
          v-on:uploadSuccess="uploadSuccess"
          :tip="null"
        ></upload>
        <!-- <template v-if="slide.click">
          <el-form-item class="small" label="跳转到：">
            <span style="word-break: break-all;">{{slide.click.href}}</span>
          </el-form-item>
        </template>-->
        <el-form-item class="small" label="跳转地址：">
          <jump ref="jump" :item="slide" :index="idx" />
        </el-form-item>
        <div class="list-item-opt">
          <a href="javascript:;" v-if="idx !== 0" @click="upBanner(idx)">
            <i class="el-icon-arrow-up"></i>
          </a>
          <a href="javascript:;" v-if="idx !== slides.length - 1" @click="downBanner(idx)">
            <i class="el-icon-arrow-down"></i>
          </a>
          <a href="javascript:;" v-if="slides.length > 1" @click="delBanner(idx)">
            <i class="el-icon-delete"></i>
          </a>
        </div>
      </div>
    </template>
    <el-button icon="el-icon-plus" style="margin-top:15px;" round @click="addBanner">添加图片项</el-button>
  </div>
</template>

<script>
import util from "@/utils/h5-marker-util.js";
import { setEditStatus } from "@/utils/index.js";
import compConfig from "@/config/h5.comp.config.js";
import upload from "@/components/h5maker/common/upload.vue";
import jump from "@/components/h5maker/common/jump.vue";

export default {
  data() {
    return {
      defaultConf: util.copyObj(compConfig["kuran-swiper"]),
      slides: this.banners
    };
  },
  components: {
    upload,
    jump
  },
  props: {
    banners: {
      type: Array
    }
  },
  watch: {
    banners: {
      handler(val) {
        this.slides = val;
        setEditStatus('true');
      },
      deep: true
    }
  },
  methods: {
    showClick(banner, idx) {
      // 轮播图只可配置外链
      this.$bus.$emit("click:show", idx, ["outside", "code"]);
    },
    upBanner(idx) {
      const tmp = util.copyObj(this.slides[idx]);
      this.slides.splice(idx, 1);
      this.slides.splice(idx - 1, 0, tmp);
    },
    downBanner(idx) {
      const tmp = util.copyObj(this.slides[idx]);
      this.slides.splice(idx, 1);
      this.slides.splice(idx + 1, 0, tmp);
    },
    delBanner(idx) {
      this.slides.splice(idx, 1);
    },
    addBanner() {
      if (this.slides.length < 10) {
        this.slides.push(util.copyObj(this.defaultConf.action.config[0]));
      } else {
        this.$alert("最多添加10个图片项！");
      }
    },
    uploadSuccess(item, img, idx) {
      console.log("uploadSuccess", item, img, idx);
    },
    
    validate () {

      let jumpIsOk = [], uploadIsOk = []
      for (let i = 0; i < this.$refs.jump.length; i++) {
        let res = this.$refs.jump[i].validateJump()
        jumpIsOk.push(res)
      }
      for (let i = 0; i < this.$refs.upload.length; i++) {
        let res = this.$refs.upload[i].validateUpload()
        uploadIsOk.push(res)
      }
      return jumpIsOk.every(item => item) && uploadIsOk.every(item => item)
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
</style>
